import moment from 'moment';

class ScheduleController {
  /* @ngInject */
  constructor($log, $rootScope, $scope, toastr, Business, ngDialog) {
    Object.assign(this, {
      $rootScope,
      $log,
      Business,
      ngDialog,
      toastr,
      active: 'hours',
      hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      minutes: ['00', '15', '30', '45'],
      meridiems: ['AM', 'PM'],
      timezones: ['Pacific', 'Central', 'Eastern'],
      schedule: {},
      holiday: {},
      slvdata: [],
      states: [],
      SLVDays: [],
      editing: false,
      stateSLVdata: {},
      SLVschedule: []
    });
    /*
        var today = moment().format('YYYY-MM-DD');
        var offsetLos_Angeles = moment.tz(today, 'America/Los_Angeles').format('Z');  // "-08:00" => -480 minutes
        console.log('offsetLos_Angeles');
        console.log(offsetLos_Angeles);
        var offsetPhoenix = moment.tz(today, 'America/Phoenix').format('Z');  // "-07:00" => -420 minutes
        console.log('offsetPhoenix');
        console.log(offsetPhoenix);
        this.offsetMinutesPhoenixLos_Angeles = this.convertStringToMinutes(offsetPhoenix) - this.convertStringToMinutes(offsetLos_Angeles);
        console.log('this.offsetMinutesPhoenixLos_Angeles');
        console.log(this.offsetMinutesPhoenixLos_Angeles);
    */

    /****************** DO NOT DELETE THIS SECTION / IT WILL BE HELPFUL *********************/

    /*
    // Los_Angeles observes DST
    // var offset1 = moment.tz("2018-11-01", 'America/Los_Angeles').format('Z z');  // -07:00 PDT
    // var offset2 = moment.tz("2018-11-21", 'America/Los_Angeles').format('Z z');  // -08:00 PST
    console.log("OFFSET-Los_Angeles");
    console.log("2018-11-01");
    var offset1 = moment.tz("2018-11-01", 'America/Los_Angeles').format('Z');  // -07:00
    console.log(offset1);
    console.log("2018-11-21");
    var offset2 = moment.tz("2018-11-21", 'America/Los_Angeles').format('Z');  // -08:00
    console.log(offset2);
    // Phoenix does not observe DST
    // var offset3 = moment.tz("2018-11-01", 'America/Phoenix').format('Z z');  // -07:00 MST
    // var offset4 = moment.tz("2018-11-21", 'America/Phoenix').format('Z z');  // -07:00 MST
    console.log("OFFSET-Phoenix");
    console.log("2018-11-01");
    var offset3 = moment.tz("2018-11-01", 'America/Phoenix').format('Z'); // -07:00
    console.log(offset3);
    console.log("2018-11-21");
    var offset4 = moment.tz("2018-11-21", 'America/Phoenix').format('Z'); // -07:00
    console.log(offset4);
    console.log("convertStringToMinutes('07:45')" + convertStringToMinutes('07:45'));
    console.log("convertStringToMinutes('-07:45')" + convertStringToMinutes('-07:45'));
    console.log("convertStringToMinutes('27:45')" + convertStringToMinutes('27:45'));
    console.log("convertStringToMinutes('-27:45')" + convertStringToMinutes('-27:45'));
    console.log("convertMinutesToTimeString(465)" + convertMinutesToTimeString(465));
    console.log("convertMinutesToTimeString(-465)" + convertMinutesToTimeString(-465));
    console.log("convertMinutesToTimeString(1665)" + convertMinutesToTimeString(1665));
    console.log("convertMinutesToTimeString(-1665)" + convertMinutesToTimeString(-1665));
    */
    // this.getSchedule();

    this.getHolidays();
    this.getSLVSchdules();
  } // REFERENCE:
  // https://simple.wikipedia.org/wiki/12-hour_clock
  // TO CONVERT BETWEEN 12H AND 24H TIME FORMATS
  // EXAMPLES:
  // "00:30:00" => "12:30AM"
  // "17:00:00" => "5:00PM"


  convertTime24to12 = time24h => {
    let [hours, minutes, seconds] = time24h.split(':');
    let hours_24_as_integer = parseInt(hours, 10);
    let modifier = '';

    if (hours === '00' || hours === '24') {
      modifier = 'AM';
      hours = '12';
    } else if (hours_24_as_integer < 12) {
      modifier = 'AM';
      hours = '' + hours_24_as_integer;
    } else if (hours_24_as_integer >= 12) {
      modifier = 'PM';
      if (hours_24_as_integer > 12) hours_24_as_integer = hours_24_as_integer - 12;
      hours = '' + hours_24_as_integer;
    }

    return hours + ':' + minutes + modifier;
  }; // EXAMPLES:
  // "12:30 AM" => "00:30:00"
  // "5:00 PM" => "17:00:00"

  convertTime12to24 = (time12h, type) => {
    let [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours.length === 1) hours = '0' + hours;

    if (hours === '12' && minutes === '00' && modifier === 'AM') {
      if (type === 'close') {
        hours = '24';
      } else {
        hours = '00';
      }
    } else if (modifier === 'AM') {
      if (hours === '12') hours = '00';
    } else if (modifier === 'PM') {
      if (hours != '12') hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}:00`;
  };

  getSLVSchdules() {
    this.Business.getSLVSchedules().then(({
      data
    }) => {
      this.slvdata = data;
    }).catch(err => {
      console.log(err);
      this.toastr.error(`Error getting SLV hours: ` + err.data.message.summary);
    });
  }

  editSLV(row) {
    this.editing = true;
    this.stateSLVdata = row;
    console.log("statedata", this.stateSLVdata);
    this.SLVschedule = this.setupSLVSchedule(this.stateSLVdata.days);
    console.log("slvSchedule", this.SLVschedule);
  }

  cancelSLV() {
    this.editing = false;
  }

  confirm() {
    const config = {
      template: "app/components/modals/confirm.tpl.html",
      data: {
        title: "Confirm Office Hours",
        content: "Are you sure you want to change these hours?"
      }
    };
    this.ngDialog.openConfirm(config).then(() => this.updateSLV());
  }

  updateSLV() {
    const convertedTimesArray = [];
    let errorMessage = "";
    this.SLVschedule.forEach(day => {
      if (!errorMessage) {
        let startTime = day.start;
        let finishTime = day.finish;
        let day_name = day.day_name;
        let short_day_name = day.day_name.substring(0, 3);
        let open_time = this.convertTime12to24(`${startTime.hour}:${startTime.minutes} ${startTime.meridiem}`, `open`);
        let close_time = this.convertTime12to24(`${finishTime.hour}:${finishTime.minutes} ${finishTime.meridiem}`, `close`);

        if (open_time === close_time) {
          errorMessage = "Start time and finish time can't be the same on " + day_name;
        }

        if (open_time > close_time) {
          errorMessage = "Start time can't be greater than finish time on " + day_name;
        }

        let hours = [{
          open_time,
          close_time
        }];
        let payload = {
          day_name,
          hours,
          short_day_name
        };
        convertedTimesArray.push(payload);
      }
    });

    if (errorMessage) {
      this.toastr.warning(errorMessage);
      return;
    }

    this.stateSLVdata.days = convertedTimesArray;
    let payload = this.stateSLVdata;
    this.Business.updateSLVSchedule(this.stateSLVdata.state_code, payload).then(() => {
      this.toastr.success(`${this.stateSLVdata.state_name}'s SLV hours updated successfully`);
      this.editing = false;
      this.$rootScope.$broadcast('business:slv-hours-by-state-updated');
      this.getSLVSchdules();
    }).catch(err => {
      console.log(err);
      this.toastr.error(`Error updating ${this.stateSLVdata.state_name}'s SLV hours: ` + err.data.message.summary);
    });
  }

  setupSLVSchedule(days) {
    let start, finish, day_name, schedule, open_time, close_time, hour, minutes;
    let scheduleArray = [];
    days.forEach(day => {
      open_time = this.convertTime24to12(day.hours[0].open_time);
      [hour, minutes] = open_time.split(":");
      start = {
        hour: hour,
        minutes: minutes.substring(0, 2),
        meridiem: minutes.substring(2)
      };
      close_time = this.convertTime24to12(day.hours[0].close_time);
      [hour, minutes] = close_time.split(":");
      finish = {
        hour: hour,
        minutes: minutes.substring(0, 2),
        meridiem: minutes.substring(2)
      };
      day_name = day.day_name;
      schedule = {
        start,
        finish,
        day_name
      };
      scheduleArray.push(schedule);
    });
    return scheduleArray;
  }

  toggleHolidaySection() {
    $(".holiday-section").toggle();
  }

  getHolidays() {
    this.Business.getHolidays().then(({
      data
    }) => {
      this.$log.log('Business Holidays: ', data);
      this.holidays = _.map(data, h => Object.assign(h, {
        holiday: moment(h.holiday).toDate()
      }));
      this.holidaysMaster = angular.copy(this.holidays);
    });
  }

  resetHolidays() {
    this.holidays = this.holidays.filter(h => !h.local);
  }

  addHoliday(holiday = {}) {
    if (holiday.title && holiday.holiday) {
      this.holidays.push(Object.assign(holiday, {
        local: true
      }));
      this.holiday = {};
    }
  }

  removeHoliday(holiday, idx) {
    if (holiday.local) {
      this.holidays.splice(idx, 1);
    } else {
      this.Business.removeHoliday(holiday).then(() => {
        this.holidays.splice(idx, 1);
        this.$rootScope.$broadcast('business:holidays-updated');
      });
    }
  }

  canSaveHolidays() {
    return !!_.find(this.holidays, {
      local: true
    });
  }

  saveHolidays() {
    this.holidays.forEach(h => {
      if (h.local) {
        this.Business.addHoliday(h).then(() => {
          delete h.local;
          this.getHolidays();
          this.$rootScope.$broadcast('business:holidays-updated');
        });
      }
    });
  } // setupDate(date) {
  //   if (date) {
  //     date = moment({ hour: date[0], minutes: date[1] }).local();
  //     date = {
  //       hour: date.format('h').toString(),
  //       minutes: date.format('m').toString(),
  //       meridiem: date.format('a').toUpperCase(),
  //     };
  //     date.minutes = date.minutes === '0' ? '00' : date.minutes;
  //     return date;
  //   }
  // }
  // printDate(open, close) {
  //   open = open.split(":");
  //   close = close.split(":")
  //   let openDate = this.setupDate(open);
  //   let closeDate = this.setupDate(close);
  //   return `${openDate.hour}:${openDate.minutes}${openDate.meridiem} - ${closeDate.hour}:${closeDate.minutes}${closeDate.meridiem} `;
  // }
  // tableTime(time) {
  //   time = moment({ hour: time[0], minutes: time[1]}).local();
  //   time = {
  //     hour: time.format('h').toString(),
  //     minutes: time.format('m').toString(),
  //     meridiem: time.format('a').toUpperCase(),
  //   };
  //   time.minutes = time.minutes === '0' ? '00' : time.minutes;
  //   return time;
  // }

  /*
    convertStringToMinutes(hours_minutes) {
      var returnValue = null;
      var factor = 1;
      try {
        var array = hours_minutes.split(':');
        var hours = parseInt(array[0]);
        if (hours < 0) {
          factor = (-1);
          hours = hours * (-1);
        }
        var minutes = parseInt(array[1]);
        returnValue = factor * (hours * 60 + minutes);
      } catch(err) {
      }
      return returnValue;
    }
    convertMinutesToTimeString(totalMinutes) {
      // IF WE PASS AFTER MIDNIGHT TO NEXT DAY
      // WE SHOULD SUBSTRACT 24 HOURS
      // TO NOT SHOW STRINGS LIKE "24:15", "27:15", ETC...
      // INSTEAD SHOW "00:15", "03:15", ETC...
      if (totalMinutes > (24 * 60)) {
        totalMinutes = totalMinutes - (24 * 60);
      // IF WE PASS BEFORE MIDNIGHT TO PREVIOUS DAY
      // WE SHOULD ADD 24 HOURS
      // TO NOT SHOW STRINGS LIKE "-00:15", "-03:15", ETC...
      // INSTEAD SHOW "23:45", "20:45", ETC...
      } else if (totalMinutes < 0) {
        totalMinutes = totalMinutes * (-1);
        totalMinutes = (24 * 60) - totalMinutes;
      }
      var hours = parseInt(totalMinutes / 60);
      var hoursString = hours.toString().padStart(2, '0');
      var minutes = totalMinutes - hours * 60;
      var minutesString = minutes.toString().padStart(2, '0');
      var returnValue = hoursString + ':' + minutesString;
      return returnValue;
    }
    convert_fromPhoenix_toLosAngeles(hours_minutes_string) {
      var totalMinutes = this.convertStringToMinutes(hours_minutes_string) - this.offsetMinutesPhoenixLos_Angeles;
      var timeString = this.convertMinutesToTimeString(totalMinutes);
      return timeString;
    }
    convert_fromLosAngeles_toPhoenix(hours_minutes_string) {
      var totalMinutes = this.convertStringToMinutes(hours_minutes_string) + this.offsetMinutesPhoenixLos_Angeles;
      var timeString = this.convertMinutesToTimeString(totalMinutes);
      return timeString;
    }
    getSchedule() {
      this.Business.getSchedule()
        .then(({ data }) => this.setupSchedule(data));
    }
    hasScheduleChanged() {
      return !angular.equals(this.schedule, this.scheduleMaster);
    }
    setupSchedule(schedule) {
      this.$log.log('Business Schedule - Phoenix: ', schedule);
      const days = angular.copy(schedule.days);
      days.forEach((day) => {
        if (day.start && day.finish) {
          day.start = this.convert_fromPhoenix_toLosAngeles(day.start);
          day.finish = this.convert_fromPhoenix_toLosAngeles(day.finish);
        }
      });
      this.$log.log('Business Schedule - LosAngeles: ', days);
      // Move Sunday to first position
      days.unshift(days.pop());
      // Pluck out start and finish time from one day and set the days availability
      // to true/false for view checkboxes
      let start,
        finish;
      _.each(days, (day) => {
        if (day.start && day.finish) {
          day.available = true;
          start = start || day.start.split(':');
          finish = finish || day.finish.split(':');
        } else {
          day.available = false;
        }
      });
      this.schedule = {
        days,
        start: start && this.setupDate(start),
        finish: finish && this.setupDate(finish),
      };
      this.scheduleMaster = angular.copy(this.schedule);
    }
    resetSchedule() {
      this.schedule = {};
      this.schedule = angular.copy(this.scheduleMaster);
    }
    confirmNewSchedule() {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: 'Confirm Office Hours',
          content: 'Are you sure you want to change these hours?',
        },
      };
      this.ngDialog.openConfirm(config).then(this.saveSchedule.bind(this));
    }
    saveSchedule() {
      let start = moment(),
        finish = moment(),
        payload = { days: {} };
      function formatter(date, original) {
        date.hour(original.meridiem == 'PM' ? parseInt(original.hour) % 12 + 12 : parseInt(original.hour) % 12);
        date.minute(original.minutes === '00' ? 0 : parseInt(original.minutes));
        return date.format('HH:mm');
      }
      this.schedule.days.forEach((day) => {
        if (day.available) {
          payload.days[day.code] = {
            start: formatter(start, this.schedule.start),
            finish: formatter(finish, this.schedule.finish),
          };
        } else {
          payload.days[day.code] = {
            start: null,
            finish: null,
          };
        }
      });
      // WE CONVERT TO PHOENIX ZONE BEFORE WE CALL THE API TO UPDATE
      for (var key in payload.days) {
        // skip loop if the property is from prototype
        if (!payload.days.hasOwnProperty(key)) continue;
        if (payload.days[key].start && payload.days[key].finish) {
          payload.days[key].start = this.convert_fromLosAngeles_toPhoenix(payload.days[key].start);
          payload.days[key].finish = this.convert_fromLosAngeles_toPhoenix(payload.days[key].finish);
        }
      }
      this.$log.log('Business Schedule - Phoenix: ', payload);
      this.Business.updateSchedule(payload)
      .then(() => {
        this.scheduleMaster = angular.copy(this.schedule);
        this.toastr.success('Schedule has been updated.');
        this.$rootScope.$broadcast('business:hours-updated');
      })
      .catch(() => this.toastr.error('Could not update schedule.'));
    }
  */


}

ScheduleController.$inject = ["$log", "$rootScope", "$scope", "toastr", "Business", "ngDialog"];
angular.module('pims').controller('ScheduleController', ScheduleController);
